import { render, staticRenderFns } from "./Son_MultiSelect.vue?vue&type=template&id=2fe45244&scoped=true&"
import script from "./Son_MultiSelect.vue?vue&type=script&lang=js&"
export * from "./Son_MultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe45244",
  null
  
)

export default component.exports